var ApplicationVersion = /** @class */ (function () {
    function ApplicationVersion() {
    }
    ApplicationVersion.version = '4.16.0';
    return ApplicationVersion;
}());
export { ApplicationVersion };
